import type { FC } from 'react';
import { getDialInNumbersUrl } from '../../../../utils/url';
import { formatPin, useDialInData } from '../../hooks/useDialInData';
import type { PhoneSectionProps } from '../../types';

const PhoneSection: FC<PhoneSectionProps> = ({
  room,
  phoneList,
  isLoading,
  phoneListError,
  pin,
  isLoadingPin,
  pinError,
}) => {
  const dialInData = useDialInData(
    phoneList,
    isLoading ?? false,
    phoneListError ?? null,
    pin ?? null,
    isLoadingPin ?? false,
    pinError ?? null,
  );

  return (
    <>
      <div className="schedule-meeting-modal__divider" />
      <div className="schedule-meeting-modal__phone-section">
        <div className="schedule-meeting-modal__input-label">Phone numbers</div>

        {dialInData.hasLicenseError ? (
          <div className="schedule-meeting-modal__error-message">
            Dial-in is only available for paid plans.
          </div>
        ) : dialInData.isLoadingPin ? (
          <div
            className="schedule-meeting-modal__phone-info"
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <div
              className="spinner-dual"
              style={{ width: '16px', height: '16px', borderWidth: '2px', margin: 0 }}
            />
            <span>Loading dial-in information...</span>
          </div>
        ) : (
          <>
            {dialInData.isLoadingPhoneList && (
              <div className="schedule-meeting-modal__phone-info">Loading phone numbers...</div>
            )}

            {dialInData.phoneListError && (
              <div className="schedule-meeting-modal__error-message">
                Unable to load phone numbers. Please try again later.
              </div>
            )}

            {!(dialInData.isLoadingPhoneList || dialInData.phoneListError) &&
              dialInData.primaryPhoneNumber && (
                <div className="schedule-meeting-modal__phone-info">
                  {dialInData.primaryPhoneNumber}
                  {phoneList?.find((p) => p.formattedNumber === dialInData.primaryPhoneNumber)
                    ?.tollFree && (
                    <span className="schedule-meeting-modal__toll-free"> (Toll-free)</span>
                  )}
                </div>
              )}

            {dialInData.pinError && !dialInData.phoneListError && (
              <div className="schedule-meeting-modal__error-message">
                Unable to load PIN. Please try again later.
              </div>
            )}

            {!dialInData.pinError && dialInData.pin && (
              <div className="schedule-meeting-modal__phone-info">
                PIN: {formatPin(dialInData.pin)}
              </div>
            )}

            {room && (
              <a
                href={getDialInNumbersUrl(room)}
                className="schedule-meeting-modal__phone-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                More phone numbers
              </a>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PhoneSection;
